import { getConfigOf } from '@/services/formatter_services/enums/DECIMAL_CONFIG';
import FORMAT_VALIDATIONS from '@/services/formatter_services/enums/FORMAT_VALIDATIONS';

const formatNumberToDecimalString = (value, locale = 'de', maximumFractionDigits = 5) => {
  if (value === null || value === undefined) value = 0;
  const safeMaxDigits = Math.min(Math.max(Number(maximumFractionDigits) || 2, 0), 20);
  return parseFloat(value).toLocaleString(locale, {
    minimumFractionDigits: Math.min(2, safeMaxDigits),
    maximumFractionDigits: safeMaxDigits,
  });
}

const formatNumberToDecimalStringWithTwoDecimalPlaces = (value, locale = 'de') => {
  return formatNumberToDecimalString(value, locale, 2);
}

const formatDecimalStringToNumber = (value, locale = 'de') => {
  const { replacements } = getConfigOf(locale);
  if (FORMAT_VALIDATIONS.ONLY_NEGATIVE_PREFIX(value)) { return }

  return parseFloat(replacements(value));
}

const formatNumberToLocaleNumber = (value, locale = 'de') => {
  if (value === null || value === undefined) value = 0;
  return parseFloat(value).toLocaleString(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}

const formatNumberToDecimalStringWithoutTrailingZeroes = (value, locale = 'de') => {
  if (value === null || value === undefined) value = 0;
  return parseFloat(value).toLocaleString(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 5,
  });
}

export { formatNumberToDecimalString, formatDecimalStringToNumber, formatNumberToLocaleNumber, formatNumberToDecimalStringWithoutTrailingZeroes, formatNumberToDecimalStringWithTwoDecimalPlaces };
